import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import FormFieldLabel from './formFieldLabel';
import FormFieldHelp from './formFieldHelp';
import FormFieldError from './formFieldError';
import { shouldTypeUseFieldset, shouldTypeUseHeadingAsLabel } from '../helpers';

import styles from '../styles/formField.module.scss';

const FormField = ({
  children = null,
  className = '',
  error = '',
  fieldId = '',
  hasError = false,
  help = '',
  isDirty = false,
  isRequired = false,
  label = '',
  schema,
  shouldUseFieldset = false,
  shouldUseHeadingAsLabel = false,
  testId = '',
  type,
}) => {
  const isHeadingLabel = shouldUseHeadingAsLabel || shouldTypeUseHeadingAsLabel(type);
  const isFieldset = (shouldUseFieldset || shouldTypeUseFieldset(type)) && !isHeadingLabel;

  const Wrapper = isFieldset ? 'fieldset' : 'div';
  const Header = isFieldset ? 'legend' : 'div';

  return (
    <Wrapper className={classnames(styles.element, className)} data-testid={testId}>
      <Header className={styles.header}>
        <FormFieldLabel
          isRequired={isRequired}
          label={label}
          fieldId={fieldId}
          LabelAddOn={schema.LabelAddOn}
          isInputLabel={isHeadingLabel}
        />
      </Header>
      <FormFieldHelp className={styles.help} help={help} />
      {children}
      <FormFieldError
        hasError={hasError}
        isDirty={isDirty}
        isHidden={schema.shouldHideErrors}
        error={error}
      />
    </Wrapper>
  );
};

FormField.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  error: PropTypes.string,
  fieldId: PropTypes.string,
  hasError: PropTypes.bool,
  help: PropTypes.string,
  isDirty: PropTypes.bool,
  isRequired: PropTypes.bool,
  label: PropTypes.string,
  schema: PropTypes.shape({
    isDisabled: PropTypes.bool,
    LabelAddOn: PropTypes.elementType,
    placeholder: PropTypes.string,
    shouldHideErrors: PropTypes.bool,
  }).isRequired,
  shouldUseFieldset: PropTypes.bool,
  shouldUseHeadingAsLabel: PropTypes.bool,
  testId: PropTypes.string,
  type: PropTypes.string.isRequired,
};

export { FormField as FormFieldStorybook };
export default React.memo(FormField);
